<script setup>
import BButton from "@/dokos-ui/components/buttons/BButton.vue";
const props = defineProps(["label", "icon"])
</script>

<template>
  <BButton theme="black" variant="ghost" currentVariant="solid" class="!rounded-full" :leadingIcon="props.icon" size="lg">
    <slot>
      {{ props.label }}
    </slot>
  </BButton>
</template>
